var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreeGraftSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 452.359,
    height: 174.005,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 61.51,
    y: 7.054,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "61.509968 67.312408 73.114845 78.91729 81.818504 84.719727 92.847206 98.064316 102.71033",
    y: 7.054,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "publickey")), /*#__PURE__*/React.createElement("path", {
    d: "M88.078 16.442a3.213 3.213 0 1 0-6.426 0 3.213 3.213 0 0 0 6.426 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 76.42,
    y: 28.891,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "76.419968 84.006836 88.658951",
    y: 28.891,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M39.701 33.378h90.328L84.865 16.442 39.701 33.378",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.914 63.372a3.213 3.213 0 1 0-6.425 0 3.213 3.213 0 0 0 6.427 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 31.257,
    y: 75.822,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "31.256968 38.843834 43.495949",
    y: 75.822,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M17.121 80.308h45.164L39.702 63.372l-22.58 16.936",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.445 80.308h45.164l-22.581-16.936",
    style: {
      fill: "#d9d9d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.33333
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.24 63.372a3.213 3.213 0 1 0-6.426 0 3.213 3.213 0 0 0 6.427 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 121.581,
    y: 75.822,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "121.58097 129.16783 133.81995",
    y: 75.822,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M107.445 80.308h45.164l-22.581-16.936-22.583 16.936",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.336 99.01a3.213 3.213 0 1 0-6.427 0 3.213 3.213 0 0 0 6.427 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 8.677,
    y: 112.588,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "8.6769686 16.263836 20.915949",
    y: 112.588,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M.188 115.945H34.06L17.122 99.011.188 115.944",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.498 99.01a3.213 3.213 0 1 0-6.426 0 3.213 3.213 0 0 0 6.426 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 53.84,
    y: 112.588,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "53.83997 61.426834 66.078949",
    y: 112.588,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M45.35 115.945h33.872L62.285 99.011l-16.936 16.933",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.82 99.01a3.213 3.213 0 1 0-6.426 0 3.213 3.213 0 0 0 6.427 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 144.161,
    y: 112.588,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "144.16096 151.74783 156.39995",
    y: 112.588,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M135.669 115.945h33.873l-16.935-16.934-16.938 16.933",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.657 99.01a3.213 3.213 0 1 0-6.425 0 3.213 3.213 0 0 0 6.426 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 98.999,
    y: 112.588,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "98.99897 106.58584 111.23795",
    y: 112.588,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M90.508 115.945h33.873l-16.936-16.934-16.937 16.933",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.593 134.647a3.213 3.213 0 1 0-6.427 0 3.213 3.213 0 0 0 6.427 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 109.645,
    y: 148.788,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "109.64497 115.87726 122.33514 128.45462 133.10674",
    y: 148.788,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "horst")), /*#__PURE__*/React.createElement("path", {
    d: "M96.152 151.58h56.453l-28.225-16.933-28.228 16.933",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.167 173.247c0-.125-.109-.125-.329-.125-.03 0-.217 0-.374-.015-.235-.031-.235-.079-.235-.172 0-.094.016-.172.03-.234l1.376-5.422c.078-.375.109-.47.907-.47.155 0 .28 0 .28-.17 0-.142-.11-.142-.296-.142h-1.328c-.267 0-.297 0-.423.188l-3.748 5.797-.844-5.719c-.032-.266-.047-.266-.329-.266h-1.388c-.189 0-.313 0-.313.188 0 .125.109.125.313.125.03 0 .218 0 .374.031.204.016.25.047.25.141 0 .062-.016.094-.046.204l-1.282 5.17c-.142.532-.423.733-1.095.765a.17.17 0 0 0-.172.187s0 .125.14.125c.125 0 .375-.015.516-.015.156-.016.172-.016.5-.016l.517.016c.17 0 .374.016.53.016.048 0 .188 0 .188-.188 0-.109-.11-.125-.204-.125-.484-.016-.655-.172-.655-.437 0-.078 0-.078.03-.219l1.375-5.53h.016l.923 6.233c.014.172.03.266.17.266.126 0 .189-.094.235-.188l4.14-6.39h.016l-1.451 5.813c-.094.36-.11.453-.875.453-.187 0-.313 0-.313.187 0 .08.08.125.156.125.125 0 .516-.015.64-.015.157-.016.407-.016.61-.016l.658.016c.201 0 .42.016.608.016.063 0 .204 0 .204-.188m0 0",
    "aria-label": "M",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.452 58.842v4.202l8.953 1.579-.969-4 5.548 1.984v1.077l3.703-.64-3.703-2.97v1.157l-7.61-2.951 1.032 3.703zm0 0",
    "aria-label": "z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.702 55.959V37.696",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.576 39.29c.797-.134 1.992-1.595 2.125-1.995.134.4 1.328 1.861 2.126 1.994",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.028 55.959V37.696",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.902 39.291c.797-.133 1.992-1.594 2.125-1.994.134.4 1.328 1.86 2.126 1.994",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.35 52.97c0-.844-.515-1.5-1.499-1.921l-1.344-.578c-.36-.173-.734-.407-1.094-.626l-2.109-1.625 2.312-1.75 2.406-1.094c.797-.311 1.329-1.062 1.329-1.874 0-1.078-.952-1.798-2.328-1.798-1.579 0-2.781.891-2.781 2.079 0 .89.531 1.453 1.625 1.703-1.579.532-2.673 1.048-3.939 1.89l-6.17-3.968c-1.69-1.094-3.407-1.687-4.844-1.687q-.258 0-.33.094l9.94 6.438-2.408 1.515v.72h4.313v-.72h-1.594l1.031-.656 1.297.703c.702.422 1.609.813 2.672 1.157-1.047.312-1.578.875-1.578 1.687 0 1.204 1.156 2.079 2.734 2.079 1.453 0 2.36-.672 2.36-1.766m-13.047-2.485v-.72h-4.375v.72zm12.28-6.97c0 .766-.89 1.391-2.108 1.391-.922 0-1.454-.422-1.454-1.11 0-.781.891-1.343 2.157-1.343.843 0 1.405.421 1.405 1.063m0 9.392c0 .67-.53 1.062-1.437 1.062-1.14 0-2.093-.5-2.093-1.313 0-.734.438-1.063 1.375-1.063 1.453.016 2.155.47 2.155 1.314m0 0",
    "aria-label": "s",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.122 91.597v-6.972",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.995 86.221c.798-.134 1.992-1.595 2.125-1.995.134.4 1.329 1.861 2.126 1.994",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.285 91.597v-6.972",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.16 86.222c.796-.134 1.991-1.595 2.124-1.995.134.4 1.328 1.861 2.126 1.995",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.445 91.597v-6.972",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.32 86.22c.797-.134 1.992-1.595 2.125-1.995.134.4 1.328 1.861 2.126 1.995",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.607 91.597v-6.972",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.484 86.22c.797-.133 1.992-1.594 2.126-1.994.133.4 1.327 1.862 2.125 1.995",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.38 127.233v-6.97",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.255 121.857c.797-.133 1.992-1.594 2.125-1.994.134.4 1.328 1.861 2.125 1.995",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.605 162.784v-6.885",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.482 157.493c.797-.134 1.992-1.595 2.125-1.995.134.4 1.328 1.862 2.125 1.995",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 180.863,
    y: 110.907,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 180.863,
    y: 110.907,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "=")), /*#__PURE__*/React.createElement("path", {
    d: "M197.088 108.377c0-.11-.078-.125-.109-.14-1.156-.314-2.375-.97-3.218-2.532-.11-.172-.125-.188-.267-.188-.093 0-.218 0-.218.125 0 .094.422.875 1 1.469h-6.078c-.156 0-.375 0-.375.218 0 .22.203.22.329.22h6.421c.157 0 .171 0 .265.063.204.155.672.514 1.266.749a6 6 0 0 0-1.266.734c-.094.094-.108.094-.265.094h-6.422c-.125 0-.329 0-.329.204 0 .218.22.218.376.218h6.078c-.578.594-1 1.39-1 1.469 0 .124.124.124.218.124.14 0 .157 0 .267-.187.374-.702.75-1.11 1.124-1.437.828-.75 1.75-1 2.094-1.093 0 0 .11-.032.11-.11m0 0",
    "aria-label": "\\u21D2",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 270.33,
    y: 7.052,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "270.32996 276.13242 281.93484 287.73727 290.63852 293.53973",
    y: 7.052,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "public")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 301.667,
    y: 7.052,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "301.66696 306.88409 311.53009",
    y: 7.052,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "key")), /*#__PURE__*/React.createElement("path", {
    d: "M296.9 16.442a3.213 3.213 0 1 0-6.426 0 3.213 3.213 0 0 0 6.426 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 285.24,
    y: 28.891,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "285.23996 292.82684 297.47894",
    y: 28.891,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M248.523 33.378h90.328l-45.164-16.936-45.164 16.936",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.738 63.372a3.213 3.213 0 1 0-6.427 0 3.213 3.213 0 0 0 6.427 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 240.077,
    y: 75.822,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "240.07697 247.66383 252.31595",
    y: 75.822,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M225.945 80.308h45.162l-22.582-16.936-22.582 16.936",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.267 115.552h45.164l-22.58-16.935",
    style: {
      fill: "#d9d9d9",
      fillOpacity: 0.35,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.33333
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 330.403,
    y: 111.066,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "330.40295 337.98984 342.64194",
    y: 111.066,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 0.35,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M316.267 115.552h45.164l-22.58-16.935-22.584 16.934",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.064 98.617a3.213 3.213 0 1 0-6.426 0 3.213 3.213 0 0 0 6.426 0z",
    style: {
      fill: "#a6a6a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#a6a6a6",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.158 99.01a3.213 3.213 0 1 0-6.427 0 3.213 3.213 0 0 0 6.427 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 217.499,
    y: 112.588,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "217.49896 225.08583 229.73795",
    y: 112.588,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M209.011 115.945h33.872l-16.938-16.934-16.934 16.933",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.32 99.01a3.213 3.213 0 1 0-6.425 0 3.213 3.213 0 0 0 6.427 0z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 262.66,
    y: 112.588,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "262.65997 270.24683 274.89896",
    y: 112.588,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M254.171 115.945h33.873L271.11 99.011l-16.936 16.933",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 307.819,
    y: 147.831,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "307.81897 315.40582 320.05795",
    y: 147.831,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 0.35,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M299.331 151.188h33.872l-16.936-16.933-16.937 16.933",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.48 134.253a3.213 3.213 0 1 0-6.426 0 3.213 3.213 0 0 0 6.426 0z",
    style: {
      fill: "#a6a6a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#a6a6a6",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 352.981,
    y: 147.831,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "352.98096 360.56784 365.21994",
    y: 147.831,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 0.35,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M344.491 151.188h33.873l-16.933-16.933-16.939 16.933",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.643 134.253a3.213 3.213 0 1 0-6.427 0 3.213 3.213 0 0 0 6.427 0z",
    style: {
      fill: "#a6a6a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#a6a6a6",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.525 55.959V37.696",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.397 39.29c.797-.133 1.992-1.595 2.125-1.995.134.4 1.328 1.862 2.126 1.995",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.851 54.022v36.571",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "3.9851,2.65673",
      strokeDashoffset: 0,
      strokeOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.976 88.999c-.797.133-1.992 1.594-2.125 1.994-.133-.4-1.328-1.861-2.125-1.994",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.945 91.597v-6.972",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.82 86.223c.798-.134 1.992-1.595 2.126-1.995.133.4 1.328 1.86 2.125 1.994",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.109 91.597v-6.972",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.982 86.219c.798-.133 1.992-1.595 2.126-1.995.133.4 1.328 1.861 2.125 1.995",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.267 126.84v-6.97",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.141 121.465c.797-.133 1.992-1.594 2.125-1.994.134.4 1.328 1.86 2.126 1.994",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.43 126.84v-6.97",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.306 121.463c.797-.133 1.992-1.594 2.126-1.994.133.4 1.327 1.862 2.125 1.995",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.786 80.308h45.164l-22.58-16.936",
    style: {
      fill: "#ffb3b3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.33333
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 369.921,
    y: 75.822,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "369.92096 377.50784 382.15994",
    y: 75.822,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M355.786 80.308h45.164l-22.58-16.936-22.583 16.936",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.583 63.372a3.213 3.213 0 1 0-6.427 0 3.213 3.213 0 0 0 6.427 0z",
    style: {
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.16 99.01a3.213 3.213 0 1 0-6.426 0 3.213 3.213 0 0 0 6.426 0z",
    style: {
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "red",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 392.499,
    y: 113.152,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "392.49896 400.08585 404.73795",
    y: 113.152,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "mss")), /*#__PURE__*/React.createElement("path", {
    d: "M384.008 115.945h33.873l-16.933-16.934-16.94 16.933",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.09 134.647a3.213 3.213 0 1 0-6.425 0 3.213 3.213 0 0 0 6.427 0z",
    style: {
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "red",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 403.141,
    y: 148.788,
    style: {
      fontSize: "13.6px",
      strokeWidth: 1.13333
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "403.14096 409.37326 415.83115 421.95062 426.60275",
    y: 148.788,
    style: {
      fontVariant: "normal",
      fontWeight: 400,
      fontSize: "10.1619px",
      fontFamily: "&quot",
      writingMode: "lr-tb",
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }, "horst")), /*#__PURE__*/React.createElement("path", {
    d: "M389.65 151.58h56.453l-28.224-16.933-28.23 16.933",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.139 173.817c0-.124-.109-.124-.329-.124-.03 0-.217 0-.374-.016-.234-.03-.234-.078-.234-.171s.016-.173.031-.235l1.374-5.422c.078-.375.11-.469.907-.469.156 0 .28 0 .28-.171 0-.142-.11-.142-.296-.142h-1.327c-.266 0-.297 0-.422.188l-3.75 5.797-.845-5.718c-.03-.267-.045-.267-.327-.267h-1.39c-.189 0-.313 0-.313.188 0 .125.11.125.312.125.032 0 .22 0 .374.032.204.016.25.046.25.14 0 .063-.014.094-.046.204l-1.28 5.172c-.142.53-.423.733-1.095.765a.17.17 0 0 0-.171.188s0 .124.14.124c.125 0 .374-.015.516-.015.156-.016.171-.016.5-.016l.515.016c.173 0 .374.015.532.015.046 0 .187 0 .187-.188 0-.109-.109-.124-.204-.124-.483-.016-.655-.173-.655-.438 0-.078 0-.078.03-.219l1.376-5.53h.015l.923 6.233c.015.172.03.266.172.266.124 0 .187-.094.233-.188l4.141-6.39h.016l-1.454 5.812c-.093.36-.109.454-.875.454-.187 0-.311 0-.311.188 0 .077.078.124.156.124.125 0 .516-.015.64-.015.157-.016.406-.016.609-.016l.657.016c.203 0 .422.015.609.015.062 0 .204 0 .204-.188m0 0",
    "aria-label": "M",
    style: {
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.358 166.283c0-.235-.204-.391-.407-.391-.218 0-.328.156-.374.297l-.953 2.953c-.047.092-.047.109-.047.109 0 .094.218.172.28.172s.095-.062.125-.11l1.315-2.81a.45.45 0 0 0 .062-.219m0 0",
    "aria-label": 0,
    style: {
      fill: "red",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13333
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.947 91.597.003-6.972",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.821 86.221c.797-.133 1.993-1.594 2.126-1.994.133.4 1.327 1.862 2.125 1.995",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.879 127.233.003-6.97",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.757 121.857c.798-.133 1.993-1.594 2.126-1.994.133.4 1.328 1.862 2.125 1.995",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.1 162.216.003-6.317",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 157.493c.798-.133 1.993-1.594 2.127-1.994.133.4 1.327 1.862 2.124 1.996",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.078 63.372c-15.047 0-28.227-11.24-28.227-25.676",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.531332,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.727 39.291c.797-.133 1.992-1.595 2.125-1.995.133.4 1.328 1.862 2.125 1.995",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 0.425052,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeGraftSmall);
export default __webpack_public_path__ + "static/media/treeGraftSmall.69fac1ba3803935ea1db11585b2d6d3d.svg";
export { ForwardRef as ReactComponent };